import { render, staticRenderFns } from "./MigrationList.vue?vue&type=template&id=691f2de1&scoped=true"
import script from "./MigrationList.vue?vue&type=script&lang=js"
export * from "./MigrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f2de1",
  null
  
)

export default component.exports